@if (isMenu) {
  <button mat-menu-item aria-label="Archive">
    <mat-icon>archive</mat-icon>
    {{ 'archiveIconLabel' | translate }}
  </button>
} @else {
  <button
    mat-icon-button
    aria-label="Archive"
    matTooltip="{{ 'archiveIconLabel' | translate }}">
    <mat-icon>archive</mat-icon>
  </button>
}
